// Liens stores de l'app mobile Yeati. Source de vérité côté app :
// yeati-app `ForceUpdateScreen` (mêmes URLs que l'écran de mise à jour forcée).
export const APP_STORE_URL = "https://apps.apple.com/fr/app/yeati-votre-cse-en-poche/id1541844567";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.glebovic.OnlyceApp&hl=fr";

// Page publique (sans authentification) — cf. routes du feature download-app.
export const DOWNLOAD_APP_PATH = "/telecharger-app";
